import { BrowserRouter } from 'react-router-dom';
import { EchoHireThemeProvider } from '@/theme/ThemeProvider';
import AppToaster from '@/components/AppToaster';
import { AuthProvider } from '@/context/AuthContext';
import AppRoutes from '@/routes/AppRoutes';

export default function App() {
  return (
    <EchoHireThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <AppToaster />
          <div className="min-h-screen bg-background font-sans text-foreground">
            <AppRoutes />
          </div>
        </AuthProvider>
      </BrowserRouter>
    </EchoHireThemeProvider>
  );
}
